import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../style.css';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Table, Collapse, Skeleton, Empty } from 'antd';
import { formatAmount, getFormattedDateForApiLogs } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import moment from 'moment';
import { JSONTree } from 'react-json-tree';
import { getPlanApiLogs, getSinglePlan } from 'api/subscriptions';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { ResetButton } from '../../../components/Atom/Button';
import LoadingSkeleton from '../../../components/Skeleton/index';
import { TIMEZONES, theme } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
const { Panel } = Collapse;

export const ViewPlanDetails = () => {
  const [apiLogs, setApiLogs] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();

  const fetchPlanData = async () => {
    const response = await getSinglePlan(location?.state?.record?.store_id || store?._id, id || location?.state?.record?.plan_id);
    return response?.data?.data || null;
    /*  if (data) {
      planApiLogs(data);
    } 
    return data;*/
  };
  function getBillingAnchorText(config) {
    if (!config || typeof config !== 'object') return 'N/A';

    const suffix = getDaySuffix(config?.day_of_month);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    if ('month' in config && 'day_of_month' in config) {
      const monthName = months[config?.month - 1];
      return `Every ${config?.day_of_month}${suffix} of ${monthName} (every year)`;
      // Or: return `${config.day_of_month}${suffix} of ${monthName} every year`;
    }

    if ('day_of_month' in config) {
      return `Every ${config?.day_of_month}${suffix} of the month`;
    }

    if ('day_of_week' in config) {
      return `Every ${days[config?.day_of_week]}`;
    }

    return 'N/A';
  }

  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return 'th';
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`plan_${id || location?.state?.record?.plan_id}`, fetchPlanData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  useEffect(() => {
    if (record) planApiLogs(record);
  }, [record]);

  const planApiLogs = async (data) => {
    const plan_id = data?.plan_id;
    const storeId = data?.store_id;
    const { start_date, end_date } = getFormattedDateForApiLogs(data);
    const response = await getPlanApiLogs(plan_id, storeId, start_date, end_date);
    if (response?.data?.success) {
      setApiLogs(response?.data?.data?.logs || null);
    }
  };
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Plan',
        href: '/subscriptions/plan',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };
  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const generalInformation = [
    { label: 'Plan ID', value: <ShortenId value={record?.plan_id} /> },
    { label: 'Name', value: record?.name || 'N/A' },
    { label: 'Active', value: record?.active === true ? 'Yes' : 'No' },
    { label: 'Usage Based', value: record?.is_usage_based === true ? 'Yes' : 'No' },
    { label: 'Subscription Exists', value: record?.subscriptionExist ? 'Yes' : 'No' },
    { label: 'Price', value: formatAmount(record?.amount, record?.currency) },
    { label: 'Currency', value: record?.currency },
    { label: 'Creation Time', value: record?.createdAt ? formatInTimeZone(record?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
    { label: 'Last Update Time', value: record?.updatedAt ? formatInTimeZone(record?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
  ];

  const columns = [
    {
      title: 'Name',
      render: (value) => value?.name,
      key: 'name',
    },
    {
      title: 'Product ID',
      render: (value) => <ShortenId value={value?.product_id} />,
      key: 'product',
    },
    {
      title: 'Quantity',
      render: (value) => value?.quantity,
      key: 'quantity',
    },
    {
      title: 'Price',
      render: (value) => formatAmount(value?.price, record?.currency),
      key: 'price',
    },
  ];
  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/subscriptions/plan', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mt-4'>Plan Detail</div>
      </div>
      <div className='subscription-details logs-details'>
        {isLoading ? (
          <LoadingSkeleton />
        ) : !record ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Plan Detail</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Description</h3>
              </div>
              <div className='description'>
                <div className='description-value empty-details'>
                  <span>{record?.description || 'No Description'}</span>
                </div>
              </div>
            </div>

            {record?.is_usage_based && (
              <div className='details-section'>
                <div className='heading-section'>
                  <h3>Pricing Models</h3>
                </div>
                <div className='detail-card'>
                  {record?.pricing_models?.length > 0 ? (
                    record?.pricing_models?.map((modelId, index) => (
                      <div key={modelId} className='detail-value'>
                        <h2>{`Pricing Model ${index + 1}`}</h2>
                        <span>
                          <ShortenId value={modelId} />
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className='empty-details'>No pricing models configured.</div>
                  )}
                </div>
              </div>
            )}

            <div className='details-section '>
              <div className='heading-section'>
                <h3>Products</h3>
              </div>
              <div className='table-container'>
                {record?.product?.length > 0 ? (
                  <Table columns={columns} dataSource={record?.product} pagination={false} />
                ) : (
                  <div className='empty-details'>
                    {' '}
                    <div>No Product</div>
                  </div>
                )}
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Billing Cycle</h3>
              </div>
              <div className='detail-card'>
                <div className='detail-value'>
                  <h2>Billing Cycle</h2> <span>{record?.billing_cycle || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Interval</h2> <span>{record?.interval || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Every</h2> <span>{record?.every || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Total Count</h2> <span>{record?.total_count || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Billing Anchor</h2>
                  <span>{getBillingAnchorText(record?.billing_cycle_anchor_config)}</span>
                </div>
              </div>
            </div>
            <Collapse expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} defaultActiveKey={['1']}>
              {apiLogs?.length > 0 && (
                <Panel header='API Logs' className='border' key='1'>
                  <div className='apiLogs'>
                    <Collapse>
                      {apiLogs?.map((data, index) => {
                        if (data?.response?.encryptionKey) {
                          delete data?.response?.encryptionKey;
                        }
                        return (
                          <Panel
                            header={
                              <div className='header-api-log'>
                                <h1>{data?.end_point_url}</h1>
                                <span className='request-type'>{data?.api_call_name}</span>
                              </div>
                            }
                            className='border'
                            key={`${index}1`}>
                            <div className=''>
                              <h1 style={{ fontWeight: 'bold' }}>Request Time</h1>
                              <p style={{ margin: '5px 0px' }}>{moment(data?.created_at).format('MMM D, YYYY h:mm:ss A')}</p>
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
                              <JSONTree key={`${index}2`} data={data?.payload ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                              <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
                              <JSONTree key={`${index}3`} data={data?.response ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                            </div>
                          </Panel>
                        );
                      })}
                    </Collapse>
                  </div>
                </Panel>
              )}
            </Collapse>
          </>
        )}
      </div>
    </>
  );
};
